import React, { FC, useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';

interface OrangeTrafficLightProps {
  total: number;
  onClick?: () => void;
  isActive?: boolean;
  animate?: boolean;
  isLoading?: boolean;
}
const OrangeTrafficLight: FC<OrangeTrafficLightProps> = ({
  total,
  onClick,
  isActive = false,
  animate = false,
  isLoading = false
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const shouldHighlight = isActive || isHovered;
  const hasItems = total > 0;
  useEffect(() => {
    if (!document.getElementById('orangeTrafficLightPulse')) {
      const style = document.createElement('style');
      style.id = 'orangeTrafficLightPulse';
      style.textContent = `
        @keyframes orangeTrafficLightPulse {
          0%, 100% {
            box-shadow: 0 0 12px 6px rgba(252, 160, 0, 1);
            opacity: 1;
          }
          50% {
            box-shadow: 0 0 0px 0px rgba(252, 160, 0, 1);
            opacity: 1;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <div
      onClick={() => hasItems && onClick?.()}
      onMouseEnter={() => hasItems && setIsHovered(true)}
      onMouseLeave={() => hasItems && setIsHovered(false)}
      className={`flex items-center justify-center text-center rounded-full relative  ${hasItems ? 'bg-orangeTrafficLight' : '#080808'}`}
      style={{
        width: '33px',
        height: '33px',
        color: '#000000',
        fontSize: '14px',
        fontWeight: 'bold',
        cursor: hasItems && onClick ? 'pointer' : 'default',
        boxShadow: shouldHighlight ? '0 0 14px 3px rgba(252, 160, 0)' : '',
        transform: shouldHighlight ? 'scale(1.1)' : 'scale(1)',
        transition: 'all 0.15s ease'
      }}
    >
      {isLoading
        ? <CircularProgress size={16} style={{ color: 'rgba(252, 160, 0, 1)' }} />
        : total
      }
      <div
        className="flex items-center justify-center rounded-full"
        style={{
          position: 'absolute',
          top: '0px',
          left: '0px',
          backgroundColor: 'transparent',
          width: '33px',
          height: '33px',
          pointerEvents: 'none',
          zIndex: 1,
          animation: animate
            ? ' orangeTrafficLightPulse 1.3s cubic-bezier(0, 2, 0.5, 1) infinite '
            : ''
        }}
      />
    </div>
  );
};

export default OrangeTrafficLight;
